import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { HeaderNavigationBase } from "@/components/application/app-navigation/header-navigation";
import { appNavItems } from "@/config/navigation";
import { useAuthStore } from "@/stores/authStore";
import { useCookieConsentStore } from "@/stores/cookieConsentStore";
import { usePermissions } from "@/hooks/usePermissions";
import { Footer } from "@/components/marketing/footer/footer";
import { cx } from "@/utils/cx";

type HeaderNavItem = Parameters<typeof HeaderNavigationBase>[0]["items"][number];

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ location }) => {
    const { isAuthenticated } = useAuthStore.getState();

    if (!isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const { hasPermission, isAdmin } = usePermissions();
  const consentStatus = useCookieConsentStore((state) => state.status);
  const items: HeaderNavItem[] = [
    ...appNavItems,
    ...(isAdmin() || hasPermission("Users.Read") ? [{ label: "Admin", href: "/admin" }] : []),
  ];
  return (
    <div className={cx("flex min-h-screen flex-col", consentStatus === "pending" && "pb-24")}>
      <HeaderNavigationBase items={items} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
